import { withDefaultCurrency } from 'common/utils/formatUtils';
import { InvestmentProductFragment, InvestmentProductInput, ProductStatus } from 'generated/graphql';

export type MapInvestmentProductToInput = (product?: InvestmentProductFragment) => InvestmentProductInput;

export const mapInvestmentProductToInput: MapInvestmentProductToInput = (
  product = {
    creationTimestamp: new Date(),
    documents: [],
    enableFinancialAdvisorCare: true,
    enableNotifications: true,
    id: '',
    status: ProductStatus.Active,
    statusChangeDate: new Date(),
  },
) => {
  return {
    amountInvested: withDefaultCurrency(product.amountInvested),
    contractNumber: product.contractNumber,
    contractSignDate: product.contractSignDate,
    currentMarketValue: withDefaultCurrency(product.currentMarketValue),
    enableFinancialAdvisorCare: product.enableFinancialAdvisorCare,
    enableNotifications: product.enableNotifications,
    financialDetailsUpdatedAt: new Date(),
    financialInstrument: product.financialInstrument,
    institutionId: product.institution?.id,
    institutionName: product.institutionName,
    name: product.name,
    note: product.note,
    paymentInfo: {
      constantSymbol: product.paymentInfo?.constantSymbol,
      ibanForPayment: product.paymentInfo?.ibanForPayment,
      specificSymbol: product.paymentInfo?.specificSymbol,
      variableSymbol: product.paymentInfo?.variableSymbol,
    },
    paymentPeriod: {
      expectedAmount: withDefaultCurrency(product.paymentPeriod?.expectedAmount),
      periodCount: product.paymentPeriod?.periodCount,
      periodTypeCode: product.paymentPeriod?.periodTypeCode,
      referenceDate: product.paymentPeriod?.expectedDate,
    },
    status: product.status,
    statusChangeDate: product.statusChangeDate,
  };
};
